export default {
      id: "icon--wtw-trackies-usage",
      viewBox: "0 0 18.8 32",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--wtw-trackies-usage",
      toString: function () {
        return this.url;
      }
    }